import { useQuery } from '@tanstack/react-query';
import { useStores } from 'index';

export const useGetExternalReportData = () => {
  const externalReportService = useStores().externalReportService;

  return useQuery({
    queryKey: ['getExternalReportData'],
    queryFn: () => externalReportService.getExternalReportData(),
    retry: false,
  });
};
